import { Fragment } from 'react';
import { ConnectedProgressBar as ProgressBar } from '~/components';

// eslint-disable-next-line react/display-name
export const withProgressBar = (Component) => (props) => (
  <Fragment>
    <ProgressBar />
    <Component {...props} />
  </Fragment>
);
